import { PartialType } from '@nestjs/swagger';
import { CreateProductoPrecioCuotaDto } from './create-producto-precio-cuota.dto';

export class UpdateProductoPrecioCuotaDto extends PartialType(CreateProductoPrecioCuotaDto) {}
